// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"b013ea86","216":"e717a66d","271":"987b228d"}[chunkId] + ".chunk.css";
};